import ActionCable, { Cable } from 'actioncable';
import { useAuth } from 'hooks';
import { FunctionComponent, PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';

const ActionCableContext = createContext<Cable | null>(null);

export const useActionCable = (): Cable | null => useContext(ActionCableContext);

const buildCableUrl = (token: string): string =>
    `${process.env.REACT_APP_WEBSOCKETS_HOST_URL}${process.env.REACT_APP_WEBSOCKETS_BASE_URL}?access_token=${token}`;

export const ActionCableProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const auth = useAuth();
    const [cable, setCable] = useState<Cable | null>(null);

    useEffect(() => {
        if (!auth.signedIn || !auth.token) {
            setCable(current => {
                current?.disconnect();
                return null;
            });
            return;
        }

        const consumer = ActionCable.createConsumer(buildCableUrl(auth.token));
        setCable(current => {
            current?.disconnect();
            return consumer;
        });

        return () => {
            consumer.disconnect();
        };
    }, [auth.signedIn, auth.token]);

    return <ActionCableContext.Provider value={cable}>{children}</ActionCableContext.Provider>;
};

export default ActionCableProvider;
